<template>
  <svg viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.499" cy="12.463" fill="none" stroke="currentColor" r="11.85" />
    <path
      :class="[$style.vertLine, { [$style.hidden]: isMinus }]"
      fill="none"
      stroke="currentColor"
      d="M12.5 6.6v11.8"
    />
    <path fill="none" stroke="currentColor" d="M6.6 12.5h11.8" />
  </svg>
</template>

<script>
export default {
  name: 'IconPlusSign',

  props: {
    isMinus: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.vertLine {
  transform-origin: center;
  transition: 0.3s opacity, 0.3s transform;
}

.hidden {
  opacity: 0;
  transform: rotate(90deg);
}
</style>
